import React from 'react';
import c from 'classnames';
import { Map } from 'immutable';

import { ImageFromField, CoreLink } from '@uncinc/react-drupal-core';

import {
  SCREEN_MOBILE,
  SCREEN_NORMAL,
  SCREEN_WIDE,
} from '../../../../config/constants';

import './style.scss';

const NodeColleagueTeaser = ({ entity, className }) => {
  const classes = c('NodeColleagueTeaser', className);
  const image = entity.getIn(['field_hero', 0]);
  const path = entity.getIn(['paths', 'nl']);
  const title = entity.getIn(['title', 0, 'value']);
  const name = entity.getIn(['field_name', 0, 'value']);
  const profession = entity.getIn(['field_profession', 0, 'value']);

  return (
    <div className={classes}>
      <ImageFromField
        field={image}
        imageStyles={Map({
          [SCREEN_MOBILE]: 'crop_standard',
          [SCREEN_NORMAL]: 'crop_standard',
          [SCREEN_WIDE]: 'crop_standard',
        })}
        lazyload
      />
      <div className="NodeColleagueTeaser__info icon-after icon-arrow_forward icon-variant-red-grey">
        <p className="h5 mb-0">
          <CoreLink to={path} title={title} className="u-link-stretch">{name}</CoreLink>
        </p>
        <p>{profession}</p>
      </div>
    </div>
  );
};

export default NodeColleagueTeaser;
